const GreenCheckIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      className={className}
    >
      <circle cx="8" cy="8" r="8" fill="#55CF90" />
      <path
        d="M11.1517 5.82559L7.15164 10.3256L5.15173 8.32556"
        stroke="#F9F6F0"
        strokeWidth="1.5"
        strokeLinecap="square"
      />
    </svg>
  );
};

export default GreenCheckIcon;
